import ShoppingListDetailContainer from './shopping_list_detail_container'

export default ShoppingListDetailContainer
